import React from 'react';

import { LazyDCScriptMigrationPage } from '@confluence/dc-script-migration/entry-points/DCScriptMigrationPage';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminDCScriptMigrationRoute = () => <LazyDCScriptMigrationPage />;

AdminDCScriptMigrationRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'adminDCScriptMigration' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
